import React from 'react';
import { useDispatch } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { GridListItem, type ItemLayoutProps } from 'app/main/components/GridList';
import { ButtonLink, Icon, showDeleteDialog, Text, useSettings } from 'app/main/components';
import { showFastAddDialog } from 'app/main/modules/components/FastAddDialog';

export default function MailsModuleListItem(props: ItemLayoutProps) {
	const dispatch = useDispatch();
	const { t } = useSettings(props.model.mail_table);

	const editMail = () => {
		dispatch(
			showFastAddDialog({
				module: 'mails',
				isUpdate: true,
				model: props.model,
				maxDialogWidth: 'sm',
				updateRefresh: props.buttonProps.updateRefresh
			})
		);
	};

	const deleteMail = () =>
		dispatch(
			showDeleteDialog({
				module: 'mails',
				id: props.model.mail_uid,
				title: props.model.mail_title,
				updateRefresh: props.buttonProps.updateRefresh
			})
		);

	const secondaryAction = (
		<>
			<IconButton onClick={editMail}>
				<Icon icon="pencil" />
			</IconButton>
			<IconButton onClick={deleteMail} edge="end">
				<Icon icon="delete" />
			</IconButton>
		</>
	);

	return (
		<GridListItem secondaryAction={secondaryAction}>
			<Grid container justifyContent="space-between" alignItems="center" spacing={1}>
				<Grid size={{ sm: 6, xs: 12 }}>
					<Grid container>
						<Grid size={12} className="inline-flex items-center">
							{/* WARNING */}
							{props.model.mail_warning_desc && (
								<Tooltip title={props.model.mail_warning_desc} arrow>
									<Icon className="mr-2" icon="alert-circle-outline" color="warning.main" />
								</Tooltip>
							)}
							{/* BLOCKED */}
							{props.model.mail_blocked_desc && (
								<Tooltip title={props.model.mail_blocked_desc} arrow>
									<Icon className="mr-2" icon="block" color="error.main" />
								</Tooltip>
							)}
							{/* DEFAULT */}
							{props.model.mail_default && (
								<Tooltip title={t('DEFAULT_ITEM')} arrow>
									<Icon className="mr-2" icon="label-variant" />
								</Tooltip>
							)}
							{/* DEMS ENABLED */}
							{props.model.mail_dems_enabled && (
								<Tooltip title={t('MAIL_LIST_ITEM_DEMS_ENABLED')} arrow>
									<Icon className="mr-2" icon="email-send-outline" />
								</Tooltip>
							)}
							{/* UNSUBSCRIBED */}
							{props.model.mail_unsubscribed_dems_uid && (
								<Tooltip title={t('MAIL_LIST_ITEM_UNSUBSCRIBED')} arrow>
									<Icon className="mr-2" icon="email-off" color="error.main" />
								</Tooltip>
							)}
							{/* DESCRIPTION */}
							<Text className="font-600" variant="subtitle2">
								{props.model.mail_description || t('MODULE_MAILS_NAME_SINGULAR')}
							</Text>
						</Grid>
						<Grid size={12}>
							{/* EMAIL ADDRESS */}
							<ButtonLink href={`mailto:${props.model.mail_title}`}>{props.model.mail_title}</ButtonLink>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={{ sm: 6, xs: 12 }}>
					<Grid container alignItems="center" spacing={1}>
						{/* LINKED PERSON */}
						{props.model.peop_uid && (
							<Grid>
								<ButtonLink
									href={`/people/details/${props.model.peop_uid}`}
									icon="card-account-details-outline"
								>
									{props.model.peop_title}
								</ButtonLink>
							</Grid>
						)}
						{/* LINKED COMPANY */}
						{props.model.comp_uid && (
							<Grid>
								<ButtonLink href={`/companies/details/${props.model.comp_uid}`} icon="domain">
									{props.model.comp_title}
								</ButtonLink>
							</Grid>
						)}
						{/* LINKED USER */}
						{props.model.user_uid && (
							<Grid>
								<ButtonLink href={`/users/details/${props.model.user_uid}`} icon="account-circle">
									{props.model.user_title}
								</ButtonLink>
							</Grid>
						)}
					</Grid>
				</Grid>
			</Grid>
		</GridListItem>
	);
}
